import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ArrowForward = createSvgIcon(
  <path d="M5.271 1.604 15.555 12 5.271 22.396l1.6 1.582L18.72 12 6.87.02l-1.6 1.583Z" />,
  'ArrowForward'
);

export { ArrowForward };
